import { render } from "./ScoreDASS21.vue?vue&type=template&id=058723b6&scoped=true"
import script from "./ScoreDASS21.vue?vue&type=script&lang=js"
export * from "./ScoreDASS21.vue?vue&type=script&lang=js"

import "./ScoreDASS21.vue?vue&type=style&index=0&id=058723b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-058723b6"]])

export default __exports__